export default __webpack_public_path__ + "05bd793cca2f146a1ddada184e83b30b.png";